import { z } from "zod";
import {
  CITY,
  CONTACT_NO,
  ONBOARDING_DATE,
  SCHOOL_NAME,
  STATE,
} from "./consts";

export const schema = z.object({
  [CITY]: z.string().optional(),
  [CONTACT_NO]: z.string().optional(),
  [ONBOARDING_DATE]: z.string().optional(),
  [SCHOOL_NAME]: z.string().optional(),
  [STATE]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
